import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function KeyOffIcon(props: IconProps) {
    return <Icon {...props} iconKey={"key_off"}/>
}
